var _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_3132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFDDCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_3132)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.72919 23V11.625C8.72919 10.6585 9.51269 9.875 10.4792 9.875H21.8542C22.8207 9.875 23.6042 10.6585 23.6042 11.625V23C23.6042 23.9665 22.8207 24.75 21.8542 24.75H10.4792C9.51269 24.75 8.72919 23.9665 8.72919 23Z",
    fill: "#FFDDCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.53033 23.6925V17.8529C8.53033 17.3568 9.33478 16.9545 10.3271 16.9545H22.0063C22.9986 16.9545 23.8031 17.3568 23.8031 17.8529V23.6925C23.8031 24.1887 22.9986 24.5909 22.0063 24.5909H10.3271C9.33478 24.5909 8.53033 24.1887 8.53033 23.6925Z",
    fill: "#FFA577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6042 9.875H21.8542C22.8207 9.875 23.6042 10.6585 23.6042 11.625V13.375M23.6042 16.875V23C23.6042 23.9665 22.8207 24.75 21.8542 24.75H10.4792C9.51269 24.75 8.72919 23.9665 8.72919 23V11.625C8.72919 10.6585 9.51269 9.875 10.4792 9.875H12.2292",
    stroke: "#FF5500",
    strokeWidth: 1.71818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3542 7.25L15.7292 9.875L18.3542 12.5",
    stroke: "#FF5500",
    strokeWidth: 1.71818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentback);
export default __webpack_public_path__ + "static/media/sentback.37e8211de88dbd4d182398a91953e5cf.svg";
export { ForwardRef as ReactComponent };